import green_exclamation_mark from "../assets/green_exclamation_mark.gif";

import { useSearchParams } from "react-router-dom";

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const username = searchParams.get("username");
  return (
    <div className="VerifyEmail">
      <div className="VerifyEmail__message">
        <div className="VerifyEmail__image">
          <img src={green_exclamation_mark} alt="green exclamation mark" />
        </div>
        <h1>PLEASE {username.toUpperCase()} VERIFY YOUR EMAIL</h1>
        <p> We sent an email to {email}</p>
        <p>
          Just click on the link we sent to your email address to complete the
          registration process.
        </p>
        <p>
          If you don't see the email, check other places it might be, like your
          junk, spam, social, or other folders.
        </p>
      </div>
    </div>
  );
}

export default VerifyEmail;
